<template>
  <footer class="simfooter" id="acfooter">
    <div class="container">
      <div class="row">
        <div class="col-5">
          <div id="logo"><img class="logo m-0" :src="ThmLogo" id="logofooter" ref="SIMmersion Logo"></div>
          <div class="copyright mt-5">
            <p class="copy" style="margin-top:77px">
              Admin Center 2.11.2 | <span name="release_date">Release Date:</span> 02/24/2025<br />
              <span name='copyright'>Copyright</span>&nbsp;{{new Date().getFullYear()}}, Simmersion
            </p>           
          </div>
        </div>

        <div class="col-7">
          <div class="row">
            <div class="col-4">&nbsp;</div>
            <div class="col-4">
              <h6 class="footer-menu-header" name="support">Support</h6>
              <ul class="p-0">
                <li class="footer-menu"><a href="https://www.simmersion.com/contact" target="_blank" name="contact_us">Contact Us</a></li>
                <li class="footer-menu"><a href="https://training.simmersion.com/privacy.html" name="privacy_policy" target="_blank">Privacy Policy</a></li>
              </ul>
            </div>
            <div class="col-4">
              <h6 class="footer-menu-header" name="training">Training</h6>
              <ul class="p-0">
                <li class="footer-menu"><a href="http://www.simmersion.com/" target="_blank">SIMmersion.com</a></li>
                <li class="footer-menu"><a href="https://www.simmersion.com/about" target="_blank" name="about">About</a></li>
                <li class="footer-menu"><a href="http://training.simmersion.com/" target="_blank" name="training_center">Training Center</a></li>
              </ul>
            </div>
          </div>

          <div class="row copyright">
            <div class="col-12">
              <p class="address text-right" name="address">
                <!--6470 Dobbin Road, Suite A, Columbia, MD 21045 &nbsp; <a class="d-block d-md-inline-block" href="tel:4432832555">+ (443) 283-2555</a>-->
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>

<style scoped>
  footer {
    background-color: #2A6693;
    padding-top:60px;
    padding-bottom:80px;
  }
  footer li, div.copyright p {
    list-style: none;
    font-size: 14px;
    line-height: 23px;
    color:#FFF;
  }
  footer li a, .copyright a {
     color:#FFF;
     text-decoration:none;
  }
  .footer-menu-header {
    color: #FFF;
  }
  .copyright {
     margin-top:30px;
  }
  img.logo {
    height: 50px;
    width: 161.54px;
  }
  footer h6 {
    font-size: 13px;
    line-height: 21px;
    font-weight: 700;
    text-transform: uppercase;
  }
</style>

<script>
  export default {
    name: "ACFooter",
    data() {
      return {
        dateline: "",
        ThmLogo: "/SIMmersion_logo-white.svg"
      }
    },
    mounted() {
      this.$bus.$on("LogoUpdateEvent", (l) => {
        this.ThmLogo="data:image/png;base64, "+l;
      });

      //this.dateline="<span name='copyright'>Copyright </span>"+new Date().getFullYear()+", SIMmersion";
    }
  }
</script>
